import React, { useId } from 'react';

// PME Trade Canada mark: rounded square in a navy → red diagonal gradient
// with a white chevron and bar. Same artwork as client/public/logo.svg;
// PNG copies are generated by scripts/make-icons.sh.
// At favicon-like sizes the strokes are drawn thicker so they stay legible.
export default function Logo({ size = 40 }) {
  const id = `pme-logo-${useId().replace(/:/g, '')}`; // unique per instance: several logos share a page
  const small = size <= 20;
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0b1f38" />
          <stop offset="0.55" stopColor="#3b1d4a" />
          <stop offset="1" stopColor="#c8102e" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="7" fill={`url(#${id})`} />
      <path d="M8 21 L16 9 L24 21" fill="none" stroke="#ffffff" strokeWidth={small ? 4 : 3.2} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 23.5 H20" stroke="#ffffff" strokeOpacity="0.85" strokeWidth={small ? 3 : 2.4} strokeLinecap="round" />
    </svg>
  );
}
